<template>
	<Autocomplete
		:default-params="{
			od: 'ASC',
			of: 'ordering',
			pageSize: 25,
		}"
		:icon="icon"
		:label="label"
		:name="name"
		display-name="Meldungsstatus"
		item-title="name"
		endpoint="report_statuses"
		data-test="report_statuses-autocomplete"
		v-bind="$attrs"
		:chips="chips"
	>
		<template v-if="chips" #chip="{ props, item }">
			<v-chip v-bind="props" label :color="item.raw.text_color"></v-chip>
		</template>
	</Autocomplete>
</template>

<script setup lang="ts">
import Autocomplete from '../Validation/Autocomplete.vue'

type ReportStatusProps = {
	icon?: string
	label?: string
	name?: string
	chips?: boolean
}

const {
	label = 'Meldungsstatus',
	name = 'reportStatuses',
	chips = false,
} = defineProps<ReportStatusProps>()
</script>

<style scoped></style>
